import { render, staticRenderFns } from "./Botones.vue?vue&type=template&id=cbba2dc6&lang=pug&"
import script from "./Botones.vue?vue&type=script&lang=js&"
export * from "./Botones.vue?vue&type=script&lang=js&"
import style0 from "./Botones.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports